module.exports = __webpack_public_path__ + "img/yl_logo.c2f6ed0e.png";